export default "/assets/images/mila-app.eec76cbaff9be820.png";